<template>
  <vx-card title="Medical Procedure">
    <div id="user-edit-tab-info">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-col w-full mb-base">
            <template>
              <vs-table
                stripe
                max-items="8"
                pagination
                search
                :data="getMedicalProcedureLookup"
              >
                <template slot="thead">
                  <vs-th>Id</vs-th>
                  <vs-th>Code</vs-th>
                  <vs-th>Description</vs-th>
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].medicalProcedureId">
                      {{ data[indextr].medicalProcedureId }}
                    </vs-td>
                    <vs-td :data="data[indextr].medicalProcedureCode">
                      {{ data[indextr].medicalProcedureCode }}
                    </vs-td>
                    <vs-td :data="data[indextr].medicalProcedureName">
                      {{ data[indextr].medicalProcedureName }}
                    </vs-td>
                    <vs-td>
                      <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                        <feather-icon
                          icon="Edit3Icon"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="editRecord(data[indextr].earningsTypeId)"
                        />
                        <feather-icon
                          icon="Trash2Icon"
                          svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                          @click="
                            confirmDeleteRecord(data[indextr].earningsTypeId)
                          "
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </template>
          </div>
        </div>
      </div>
    </div>
  </vx-card>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";

export default {
  data() {
    return {
      medicalProcedure: {
        medicalProcedureId: 0,
        medicalProcedureCode: "",
        medicalProcedureName: "",
      },
    };
  },
  created() {
    this.$store.dispatch("lookup/getAllMedicalProcedureLookup").catch((err) => {
      console.log(err);
    });
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    getMedicalProcedureLookup() {
      return this.$store.state.lookup.getAllMedicalProcedureLookup;
    },
  },
};
</script>
